/**
 * Export and download response data as .XLSX file.
 *
 * @param {object} response
 * @param {string} reportName
 */
const exportAsXls = (response, reportName) => {
    var headers = response.headers;
    var contentType = headers['content-type'];
    const blob = new Blob([response.data], {type: contentType});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${reportName}.xlsx`;
    link.target = '_blank';
    document.body.append(link);
    link.click();
    document.body.removeChild(link);
}


export default exportAsXls;